// components/Footer.js
import React from "react";
import "../assets/css/Footer.css";
import chatbotImg from "../assets/images/chatbot-img.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} Nitor Infotech. All rights reserved.</p>
        {/* <p>
          <a href="/privacy-policy">Privacy Policy</a> | <a href="/terms">Terms of Service</a>
        </p> */}
      </div>
      <a href="/help-desk" className="btn chatbotbtn mt-3">
        <img src={chatbotImg} />
      </a>
    </footer>
  );
};

export default Footer;
